//Product default selection(first size) has been removed and also added the validation check
  const urlParams = new URLSearchParams(window.location.search);
  
  const variants = JSON.parse(document.querySelector('script[data-variant-picker-variants]')?.textContent ?? '{}');
  
  function isMobile() {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return false;
    }

    const byWidth = window.matchMedia('(max-width: 767px)').matches;
    const byPointer = window.matchMedia('(pointer: coarse)').matches;

    return byWidth || byPointer;
  }
  
  function selectVariant(index) {
    const valueLabel = document.getElementById("value_label");
    const labelElement = valueLabel.getElementsByClassName("productVariant__pill");
    const formButton = document.getElementById("formButton");
    const buttonsInForm = formButton.getElementsByClassName("button-validation");
    labelElement[index].classList.add("selected");
    const errorDiv = document.getElementById("sizeError");
  
    const valueLabelMob = document.getElementById("value_label_mobile");
    const labelElementMob = valueLabelMob.getElementsByClassName("productVariant__pill");
  
    for(let i = 0; i < labelElementMob.length; i++) {
      labelElementMob[i].classList.remove("selected");
    }
    labelElementMob[index].classList.add("selected");
  
    buttonsInForm[0].setAttribute('type', 'submit');
  
    errorDiv.innerHTML = "";
    let indexArray = [];
    for (let i = 0; i < labelElement.length; i++) {
      if(labelElement[i].getAttribute("no-available") === null && indexArray.length < 1){
        indexArray.push(i);
      }
    }
  
    if(window.location.href.includes("products")){
      updateURLParameter(indexArray, index);
    }
  }
  
  function updateURLParameter(array, index) {
    const urlParams = new URLSearchParams(window.location.search);
    const variants = JSON.parse(document.querySelector('script[data-variant-picker-variants]').textContent);
    if (!urlParams.get('variant') && array[0] == index) {
      const queryString = new URL(window.location.href);
      queryString.searchParams.append('variant', variants[index].id);
      history.pushState(null, '', queryString.href);
    }
  }
  
  function findPosition(obj) {
      let currenttop = -300;
      if (obj && obj.offsetParent) {
          do {
              currenttop += obj.offsetTop;
          } while ((obj = obj.offsetParent));
          return currenttop;
      }
      return 0; // Return a default value if obj is null
  }
  
  function handleBackDropClick() {
    document.getElementsByClassName('common__backdrop')[0].addEventListener('click', () => {
      toggleMobileVariantSelection()
    })
  }
  
  function updateNoAvailaibleMobileOptions() {
    const varientElements = document
      .querySelectorAll('.productVariant__container')[0]
      .querySelectorAll('.productVariant__pills > label')
    const noAvailArray = []
  
    varientElements.length && [...varientElements].filter((el, idx) => 
        { if (el.hasAttribute('no-available')) { noAvailArray.push(idx) } }
    )
  
    const mobileVarientElements = document.querySelectorAll('.product__variant__picker--mobile')[0]
        .querySelectorAll('.productVariant__pills > label')
  
    mobileVarientElements.length && [...mobileVarientElements]
    .forEach((el, index) => { if(noAvailArray.includes(index)) { el.setAttribute('no-available', true) } })
  }
  
  function toggleMobileVariantSelection(
    show = false
  ) {
    const variantSizeSelection = document.getElementsByClassName('product__variant__picker--mobile')[0]
    const mobileCartBtn = document.getElementsByClassName('mobile--cartbtn')[0]
    const backdropElem = document.getElementsByClassName('common__backdrop')[0]
  
    if(show) {
      variantSizeSelection.classList.add('show')
      mobileCartBtn.classList.add('mobile--cartbtn--fixed')
      backdropElem.classList.add('show')
      handleBackDropClick()
      updateNoAvailaibleMobileOptions()
    } else {
      variantSizeSelection.classList.remove('show')
      mobileCartBtn.classList.remove('mobile--cartbtn--fixed')
      backdropElem.classList.remove('show')
      document.getElementsByClassName('common__backdrop')[0]
        .removeEventListener('click', handleBackDropClick)
    }
  }
  
  function mobileSizeCartNudgeAnimation() {
    const shakeXAnimateElem = document
      .querySelectorAll('.product__variant__picker--mobile .productVariant__pills')[0]
      
    shakeXAnimateElem.classList.add('animate__animated', 'animate__shakeX')
    
    shakeXAnimateElem.addEventListener('animationend', () => {
      shakeXAnimateElem.classList.remove('animate__animated', 'animate__shakeX')
    });
  }
  
  function buttonOnclick(index) {
      const formButton = document.getElementById("formButton");
      const buttonsInForm = formButton.getElementsByClassName("button-validation");
      const errorDiv = document.getElementById("sizeError");
      const mobileCartBtn = document.getElementsByClassName('mobile--cartbtn')[0]

      if(isMobile() && buttonsInForm[index].getAttribute('type') === "button"){
          if (mobileCartBtn.classList.contains('mobile--cartbtn--fixed')) {
            mobileSizeCartNudgeAnimation()
          }
          toggleMobileVariantSelection(true)
      } else if (buttonsInForm[index].getAttribute('type') === "button") {
          errorDiv.innerHTML = "Please select the size";
      } else if(isMobile() && buttonsInForm[index].getAttribute('type') === "submit") {
        toggleMobileVariantSelection()
      }
  }
  
  // if(urlParams.get('variant') != null){
  //   for(let i=0; i < variants.length; i++){
  //     if(variants[i].id == urlParams.get('variant')){
  //       selectVariant(i);
  //     }
  //   }
  // }

  document.querySelector('#value_label .productVariant__pill.selected')?.click();

  document.querySelector('.gokwikBuyNow__btn')?.addEventListener("click", () => {
    // buttonOnclick(0);
    const selectedVariant = new URLSearchParams(window.location.search)?.get("variant");
    if (selectedVariant) {
      for (let i = 0; i < variants.length; i++) {
        if (variants[i]?.id == selectedVariant) {
          onBuyNowClick(this);
        }
      }
    }
  });

  const mobileAddToCartListener = () => {
    const triggerDiv = document.getElementById('size-chart_btn');
    if (triggerDiv) {
      window.addEventListener('scroll', function() {
        const triggerDiv = document.getElementById('size-chart_btn');
        const targetDiv = document.getElementsByClassName('mobile--cartbtn')[0];

        const triggerPosition = triggerDiv.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
      
        if (triggerPosition < windowHeight) {
            targetDiv.classList.add('anim-slidein')
        }
        else{
            targetDiv.classList.remove('anim-slidein')
        }
      });
    }
  }
  

  const desktopNavFixedOnScroll = () => {
    window.addEventListener('scroll', () => {
    
      const scrollTop = document.documentElement.scrollTop
    /*
       SR-INFORMATION :- when going live , swap the below lines of code.
    */
    //  scrollTop > 124
   
      if (scrollTop > 67) {
          document.getElementsByClassName('navigationMainLinks')[0].classList.add('navigationMainLinks--fixed')
      } else {
          document.getElementsByClassName('navigationMainLinks')[0].classList.remove('navigationMainLinks--fixed')
      }
    })
  }  
  
  desktopNavFixedOnScroll()  
  mobileAddToCartListener()
 
const jdgmStarRatingReviewApp = () => {
    const badgeElement = document.querySelector('.jdgm-prev-badge');
    if (badgeElement) {
        const numberOfReviews = parseInt(badgeElement?.dataset?.numberOfReviews || '0', 10);
        let reviewTxt = badgeElement?.querySelector('.jdgm-prev-badge__text--review');
        if (!reviewTxt) {
            reviewTxt = document.createElement('span');
            if (reviewTxt) {
                reviewTxt.className = 'jdgm-prev-badge__text--review';
                reviewTxt.innerHTML = `${numberOfReviews}${numberOfReviews === 1 ? '&nbsp; Review' : '&nbsp; Reviews'}`;
                badgeElement.appendChild(reviewTxt);
            }
        }

        const customSection = document.querySelector('.app__starRatingBadge');
        if (customSection && numberOfReviews === 0) {
            customSection?.classList.add('app__starRatingBadge--hide');
        }
    }
}
jdgmStarRatingReviewApp()